import * as angular from 'angular';
import uiRouter from 'angular-ui-router';
import RouterProvider from './router.provider';

export default angular
  .module('router', [uiRouter])
  .provider('RouterService', RouterProvider)
  .name;



// WEBPACK FOOTER //
// ./src/app/core/router/router.module.js